import { useEffect } from "react";
const useCloseOnEscape = ({ isOpen, close }) => {
  useEffect(() => {
    if (isOpen) {
      const closeOnEscapeKey = (event) => {
        if (event.key === "Escape") {
          close();
        }
      };
      window.addEventListener("keydown", closeOnEscapeKey);
      return () => {
        window.removeEventListener("keydown", closeOnEscapeKey);
      };
    }
  }, [close, isOpen]);
};
const useCloseOnClickOutside = ({ isOpen, close, contents, outside }) => {
  useEffect(() => {
    if (isOpen) {
      const closeOnClickOutside = (event) => {
        const target = event.target;
        if (target instanceof Node && (!document.body.contains(target) || target === document.body || contents.some((it) => it && it.contains(target)))) {
          return;
        }
        if (contents.every((it) => it === null)) {
          return;
        }
        close();
      };
      (outside ?? window).addEventListener("click", closeOnClickOutside);
      return () => {
        (outside ?? window).removeEventListener("click", closeOnClickOutside);
      };
    }
  }, [close, isOpen, contents, outside]);
};
export {
  useCloseOnClickOutside,
  useCloseOnEscape
};
//# sourceMappingURL=useCloseOnEscapeOrClickOutside.js.map
